import React from 'react';
import waveLogo from '../../assets/logo_wave.jpg';
import orangeLogo from '../../assets/logo_om.png';

export function WaveLogo({ size = 40, className = '' }) {
  return (
    <img
      src={waveLogo}
      alt="Wave"
      width={size}
      height={size}
      className={`pp-method-logo ${className}`.trim()}
      draggable={false}
    />
  );
}

export function OrangeMoneyLogo({ size = 40, className = '' }) {
  return (
    <img
      src={orangeLogo}
      alt="Orange Money"
      width={size}
      height={size}
      className={`pp-method-logo ${className}`.trim()}
      draggable={false}
    />
  );
}
